import { useState, useEffect } from "react";
import { Row, Col, Flex } from "antd";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../../../utils/dayjs";
import { HollowDotsSpinner } from "react-epic-spinners";
import { BirthdayCakeIcon } from "../../../../../assets/icons";
import ReturnImg from "../../../../../utils/ReturnImg";

const WorkEvents = () => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const { activeEmployees } = useSelector((state) => state.employeesList);

  const [eventData, setEventData] = useState([]);

  const birthdays = () => {
    const ditlindja = activeEmployees.filter((el) => {
      const dob = el?.employeeDayOfBirth && dayjsTZ(el.employeeDayOfBirth);

      const isUpcomingBirthday =
        !!dob &&
        dob.month() === dayjsTZ().month() &&
        dob.date() >= dayjsTZ().date();
      return isUpcomingBirthday;
    });
    setEventData(ditlindja);
  };

  useEffect(() => {
    if (!!activeEmployees) {
      birthdays();
    }
  }, [activeEmployees]);

  function compare(a, b) {
    if (
      dayjsTZ(a.employeeDayOfBirth).format("DD") <
      dayjsTZ(b.employeeDayOfBirth).format("DD")
    ) {
      return -1;
    }
    if (
      dayjsTZ(a.employeeDayOfBirth).format("DD") >
      dayjsTZ(b.employeeDayOfBirth).format("DD")
    ) {
      return 1;
    }
    return 0;
  }

  return !!activeEmployees ? (
    <div className={`birthday-card-kryefaqja ${isDarkMode ? "dark" : ""}`}>
      {eventData.length > 0 ? (
        <div className="events">
          {eventData.sort(compare).map((data) => {
            const isBd =
              dayjsTZ().format("DD/MM") ===
              dayjsTZ(data.employeeDayOfBirth).format("DD/MM");
            return (
              <div className="anniversary" key={data?.employeeId}>
                <Row gutter={16} key={data?.employeeId}>
                  <Col>
                    <ReturnImg
                      width={40}
                      height={40}
                      borderRadius={50}
                      defaultImg={
                        <BirthdayCakeIcon fill={isBd ? "#f5b400" : ""} />
                      }
                      className={isBd ? "hasBirthday" : ""}
                      googleDriveFileId={data?.googleDriveFileId}
                    />
                  </Col>
                  <Flex vertical>
                    <Flex align="center" gap={5} wrap={"wrap"}>
                      <span style={{ width: "fit-content" }}>
                        {data?.employeeFirstName} {data?.employeeLastName} -{" "}
                      </span>
                      <span>
                        {dayjsTZ(data?.employeeDayOfBirth).format("DD/MM/YYYY")}
                      </span>
                    </Flex>
                    {isBd ? (
                      <span className="hasBirthdayText">
                        Gëzuar Ditëlindjen
                      </span>
                    ) : (
                      "Ditëlindje"
                    )}
                  </Flex>
                </Row>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="ska-dtl-muaj">Nuk ka ditëlindje për këtë muaj</div>
      )}
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <HollowDotsSpinner color="#1da193" size={24} />
    </div>
  );
};
export default WorkEvents;
